import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import type { ConnectorResponse } from "@/api";
import { BannerAction } from "@/components/BannerAction";
import { InlineNotice } from "@/components/InlineNotice";
import { usePermissions } from "@/features/account/useCurrentUser";

/**
 * An integration's own connector (HubSpot's MCP server, say): its name, sign-in and who can use it are the
 * integration's, set on Admin > Integrations; people who can edit it govern its tools here (MHS-1080, MHS-1081).
 */
export function IntegrationManagedNotice({ connector }: Readonly<{ connector: ConnectorResponse }>) {
  const { t } = useTranslation("connectors");
  const navigate = useNavigate();
  const { isPlatformAdmin } = usePermissions();
  const integration = connector.integrationName ?? connector.name;
  const canEdit = connector.currentUserRole === "admin" || connector.currentUserRole === "editor";
  const action =
    isPlatformAdmin && connector.integrationUuid ? (
      <BannerAction onClick={() => navigate(`/admin/integrations/${connector.integrationUuid}`)}>
        {t("orgConnector.open", { integration })}
      </BannerAction>
    ) : undefined;
  return (
    <InlineNotice tone="info" action={action}>
      {t(canEdit ? "orgConnector.managed" : "orgConnector.youCanUse", { integration })}
    </InlineNotice>
  );
}
